import { Button, TextField } from "@mui/material";

import React from "react";
import useAlertBannerTab from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/banner/useAlertBannerTab";

const AlertBannerTab = () => {
  const {
    alertBannerText,
    isSubmitting,
    handleBanner,
    handleCancel,
    handleAlertBannerTextChange,
  } = useAlertBannerTab();

  return (
    <div className="patient-modal__section">
      <div className="patient-form__row">
        <div className="patient-form__col--full">
          <TextField
            id="alertBanner"
            name="alertBanner"
            value={alertBannerText || ""}
            label="Alert Banner"
            multiline
            minRows="4"
            fullWidth
            variant="outlined"
            disabled={isSubmitting}
            inputProps={{ maxLength: 500 }}
            onChange={(event) =>
              handleAlertBannerTextChange(event.target.value)
            }
          />
        </div>
      </div>

      <div className="patient-form__row patient-form__row--centered">
        <Button
          variant="outlined"
          color="secondary"
          disabled={isSubmitting}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="secondary"
          disabled={isSubmitting}
          onClick={handleBanner}
        >
          {isSubmitting ? "Saving..." : "Save"}
        </Button>
      </div>
    </div>
  );
};

export default AlertBannerTab;
